import { service } from '@ember/service';
import AwayMessageCustomizer from './away-message-customizer.gjs';
import Component from '@glimmer/component';
import ContactsPage from './contacts-page.gjs';
import ConversationListPage from './conversation-list-page.gjs';
import ConversationPage from './conversation-page.gjs';
import styles from './ember-messaging-client.module.scss';
import svgJar from 'ember-svg-jar/helpers/svg-jar';

export default class EmberMessagingClient extends Component {
  @service messaging;
  @service messagingConversation;

  <template>
    <div
      id="ember-messaging-client"
      class="{{styles.component}} messaging-client"
      data-test-ember-messaging-client
      ...attributes
    >
      {{#if this.messaging.loadApp.isRunning}}
        <div class="spinner" data-test-loading-spinner>
          {{svgJar "messaging-spinner"}}
        </div>
      {{else if this.messaging.contactPageActive}}
        <ContactsPage />
      {{else if this.messagingConversation.selectedConversation}}
        <ConversationPage />
      {{else if this.messaging.settingAwayStatus}}
        <AwayMessageCustomizer />
      {{else}}
        <ConversationListPage />
      {{/if}}
    </div>
  </template>
}
